import { CategoriesResponseItem, ITheme, StoreMetadata } from "@commons-monorepo/types";
import { createContext } from "react";

export const FooterContext = createContext<{
  theme: ITheme;
  data: {
    storeMetadata: StoreMetadata;
    hasOffers: boolean;
    hasWholesale: boolean;
    hasServices: boolean;
    storeUseSubdomain: boolean;
    url: string;
    categories: CategoriesResponseItem[];
  };
}>({
  theme: {} as ITheme,
  data: {
    storeMetadata: {} as StoreMetadata,
    hasOffers: true,
    hasWholesale: true,
    hasServices: true,
    storeUseSubdomain: true,
    url: "",
    categories: [],
  },
});
